<template>
    <div
        v-if="isVisible"
        class="sidebar-value"
        ref="sidebarValue"
    >
        <div class="d-flex">
            <icon
                small
                color="n3"
                icon="User"
                class="icon"
            />
            <div class="font-italic body-2 ml-3">
                <template v-if="cpInviteSentAt">
                    {{ $t('Client portal invite sent on {0}').format(formatDate(parseSysDate(cpInviteSentAt))) }}
                </template>
                <template v-else>
                    {{ $t('Client portal invite has not been sent') }}
                </template>
            </div>
        </div>
        <div
            v-if="!overrideCpInviteSentAt"
            class="ml-4"
        >
            <secondary-button
                v-if="canEditClient"
                small
                color="primary"
                :loading="loader.isLoading"
                @click="onSendCpInvite(contact.id)"
            >
                {{ cpInviteSentAt ? $t('Resend invite') : $t('Send invite') }}
            </secondary-button>
        </div>
    </div>
</template>

<script>
import {formatCustomFieldValue} from "../../../composables/use-custom-fields";
import {computed, reactive, ref} from "@vue/composition-api";
import {formatDate, parseSysDate} from "../../../plugins/formatting";
import errorDialog from "@/views/ErrorDialog/errorDialog";
import ApiContact from '@/api/contact/contact'
import FeedbackNotificationModule from "@/store/modules/feedback_notification";
import {$t} from "@/i18n";
import Loader from "@/utility/loader";
import AccountModule from "@/store/modules/account";
import RightsModule from "@/composables/use-rights";
import AppModule from '@/store/modules/app'

export default {
    name: "CpInviteField",
    methods: {parseSysDate, formatDate},
    props: {
        contact: {
            type: Object,
            required: true
        },
        client: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const { rights_masks } = AppModule();
        const { can_edit_client } = RightsModule();
        const { isFeatureEnabled } = AccountModule();
        const sidebarValues = ref(null);
        const {showFeedbackNotification} = FeedbackNotificationModule();
        const loader = reactive(new Loader())
        const overrideCpInviteSentAt = ref(null)

        // Note: instead of using const { can_edit_client } = RightsModule();
        // We do it like so, this is because can_edit_client check accounts_info.clients we get from /generate
        // After adding client this is not updated
        // this seems to be the only place where can_edit_client is really used, but should be dealt with at some point
        // Yuck
        const canEditClient = computed(function() {
            return (props.client.rights & rights_masks.value.manage_client) === rights_masks.value.manage_client;
        });

        const isVisible = computed(() => {
            return isFeatureEnabled(props.client.account_id, "client_portal", false) && props.client.cp_is_active && props.contact.rights && props.contact.person_id
        })

        const cpInviteSentAt = computed(() => {
            return overrideCpInviteSentAt.value ? overrideCpInviteSentAt.value : props.contact.cp_invite_sent_at
        })

        const onSendCpInvite = async (contactId) => {
            await loader.withLoader(async () => {
                try {
                    const res = await ApiContact.sendCpInvite(contactId)
                    showFeedbackNotification($t('Invite sent'))
                    overrideCpInviteSentAt.value = res.cp_invite_sent_at

                } catch (e) {
                    errorDialog.showError(e)
                }
            })
        }

        return {
            formatCustomFieldValue,
            sidebarValues,
            onSendCpInvite,
            loader,
            cpInviteSentAt,
            overrideCpInviteSentAt,
            isVisible,
            canEditClient
        };
    }
};
</script>
<style scoped lang="scss">
.text-wrapping {
    white-space: nowrap;
}
</style>